<ion-header>
  <ion-toolbar>
    <ion-icon slot="start" name="chevron-back-outline" value="exit" (click)="dismiss()"></ion-icon>

    <div class="picDiv" slot="start">
      <img (click)="openProfile()" src="{{otherSoul.firstPic}}" class="chatPic" (error)="onImageError($event)">
    </div>

    <div class="nameInChat">
      {{otherSoul.firstName}}
      <img *ngIf="otherSoul?.userValidated" class="userValidated" src="assets/imgs/new-check-img.svg">
    </div>
  </ion-toolbar>
</ion-header>

<ion-content id="contentDiv">
  <ion-list lines="none">

    <!-- Talking to verified -->
    <div *ngIf="otherSoul?.userValidated && !userData?.userValidated" class="validated">
      <div class="banner">
        <p>{{ 'youAreChattingWithVerifiedProfile' | translate }} <a (click)="handleValidation()">{{ 'verifyYourProfileToo'
            | translate }}</a></p>
      </div>
    </div>

    <!-- Verify your profile -->
    <div *ngIf="!otherSoul?.userValidated && !userData?.userValidated" class="validated">
      <div class="banner">
        <p>{{ 'secureVegMatch' | translate }} <a (click)="handleValidation()">{{ 'verifyYourProfile' | translate }}</a>
        </p>
      </div>
    </div>

    <div class="new-vegmatch" *ngIf="isLoaded && messages.length == 0">
      {{ 'newVegMatchSayHi' | translate }}
    </div>

    <div class="message-item" *ngFor="let aMessage of messages">

      <!-- Day Tag-->
      <div *ngIf="aMessage.newday" class="date">
        {{aMessage.date}}
      </div>

      <!-- Message Item-->

      <ion-item-sliding [id]="aMessage?._id.$oid + '-sliding'" #slidingItemRef>
        <ion-item lines="none" class="message-item" [class.reacted-message-item]="aMessage.reaction === 1"
          (touchstart)="handleTouchStart(aMessage)" (touchend)="handleTouchEnd(aMessage)">

          <div class="message-container {{aMessage.position}}">

            <!-- Big Bubble-->
            <div class="chat-bubble {{aMessage.position}}" [id]="aMessage?._id.$oid + '-bubble'"
              [class.position-{{aMessage.position}}]="true" [class.has-reply]="!!aMessage.inResponseTo"
              [class.has-reaction]="aMessage.reaction == 1">

              <!-- Response to-->
              <div *ngIf="aMessage.inResponseTo" class="replied-to-snippet {{aMessage.position}}"
                (click)="scrollToRespondedMessage(aMessage.inResponseTo.$oid)">
                <div class="replied-to-header">{{ aMessage.inResponseTo.owner }}</div>
                <div *ngIf="messagesMap.get(aMessage.inResponseTo.$oid)?.filename"
                  class="replied-to-content replied-to-content--audio">
                  <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
                  Audio {{ messagesMap.get(aMessage.inResponseTo.$oid)?.duration ? '(' +
                  messagesMap.get(aMessage.inResponseTo.$oid)?.duration + 's)' : '' }}
                </div>
                <div *ngIf="!messagesMap.get(aMessage.inResponseTo.$oid)?.filename"
                  class="replied-to-content replied-to-content--text">
                  {{ messagesMap.get(aMessage.inResponseTo.$oid)?.message }}
                </div>
              </div>

              <!-- Audio -->
              <div class="message-content-wrapper">
                <div *ngIf="aMessage.filename" class="message-content message-content--audio">
                  <div class="audio-player">
                    <ion-button fill="clear" size="small" class="play-pause-button"
                      (click)="aMessage.isPlaying ? mediaSP.pauseAudio(aMessage) : mediaSP.playAudio(aMessage)">
                      <ion-icon [name]="aMessage.isPlaying ? 'pause-circle' : 'play-circle'" slot="icon-only"
                        class="audio-control-icon"></ion-icon>
                    </ion-button>
                    <div class="audio-track">
                      <div class="audio-progress" [style.width.%]="aMessage.playbackProgress || 0"></div>
                      <div class="audio-scrubber" *ngIf="aMessage.isPlaying"></div>
                    </div>
                    <span class="audio-duration">{{ (aMessage.isPlaying ? (aMessage.currentTimePlayed || 0) :
                      (aMessage.duration || 0)) | number:'1.0-0' }}s</span>
                  </div>
                </div>

                <div *ngIf="!aMessage.filename" class="message-content message-content--text selectext">
                  {{aMessage.message}}
                </div>
              </div>

              <!-- Message Time and Status -->
              <div class="message-meta {{aMessage.position}}">
                <span class="message-time">{{aMessage.time}}</span>
                <ion-icon
                  *ngIf="aMessage.filename==null && aMessage.position == 'right' && aMessage.read!=null && aMessage.read!=undefined && aMessage.read"
                  name="checkmark-done-outline" class="message-status-icon message-status-icon--read">
                </ion-icon>
                <ion-icon *ngIf="aMessage.position === 'right' && !aMessage.read" name="checkmark-outline"
                  class="message-status-icon message-status-icon--sent">
                </ion-icon>
              </div>

              <!-- Reaction Badge -->
              <div *ngIf="aMessage.reaction == 1" class="reaction-badge {{aMessage.position}}">
                <img src="assets/imgs/likegreenbg.svg" alt="Liked" class="reaction-icon">
              </div>
            </div>
          </div>
        </ion-item>

        <!-- Reply Icon-->
        <ion-item-options side="start" (ionSwipe)="showRespondMessage(aMessage, slidingItemRef)">
          <ion-item-option class="reply-option-background" (click)="showRespondMessage(aMessage, slidingItemRef)">
            <ion-icon name="arrow-undo-outline" slot="icon-only" class="reply-swipe-icon"></ion-icon>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>

      <div *ngIf="aMessage.reactionHint" class="message-hint {{aMessage.position}}">
        {{"doubleClickToLike" | translate}}
      </div>

      <div *ngIf="aMessage.respondHint" class="message-hint {{aMessage.position}}">
        {{"swipeRightToReply" | translate}}
      </div>

      <div *ngIf="aMessage.readingConfirmationCallout" class="reading-confirmation-callout"
        (click)="openAvocadoStore()">
        <div>{{ "doYouWantToKnowIfTheyReadYourMessage" | translate }} <a>{{ "yes" | translate }}!</a></div>
      </div>
    </div>
  </ion-list>

  <!-- Send Message Bar-->

  <div class="send-message-content" [class.has-fab-button]="showFab">

    <ion-button (click)="scrollToBottom()" *ngIf="showFab">
      <ion-icon size="large" name="chevron-down-circle-outline"></ion-icon>
    </ion-button>

    <!-- Regular Message-->
    <div *ngIf="!mediaSP.recording">
      <form [formGroup]="myForm" class="message-form">

        <!-- Response to-->
        <div class="textAreaWrapper"  [class.has-reply]="respondingMessage" [class.has-content]="theMsgControl.value.length>0||respondingMessage">

          <!--Response-->
          <div *ngIf="respondingMessage" class="replied-to-snippet {{respondedMessage.position}}">
            <div class="replied-to-header">
              <ng-container *ngIf="respondedMessage?.position == 'right'">
                {{ 'you' | translate }}
              </ng-container>
              <ng-container *ngIf="respondedMessage?.position == 'left'">
                {{ otherSoul?.firstName }} </ng-container>
            </div>

            <div *ngIf="respondedMessage?.filename" class="replied-to-content replied-to-content--audio">
              <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
              Audio {{ respondedMessage?.duration ? '(' + respondedMessage?.duration + 's)' : '' }}
            </div>
            <div *ngIf="!respondedMessage?.filename" class="replied-to-content replied-to-content--text">
              {{ respondedMessage?.message }}
            </div>
            <ion-icon name="close" (click)="dismissRespondMessage()" class="close-icon"></ion-icon>
          </div>
          <ion-item lines="none" class="textAreaItem">
            <ion-textarea rows="1" #chatInput spellcheck="true" [autoGrow]="true" autosize="true" autocomplete="on"
              (ionFocus)="changeUserTypingState()" (ionBlur)="changeUserTypingState()" autocorrect="on"
              formControlName="msgControl" placeholder="{{ 'typeYourMessage' | translate }}" clearInput>
            </ion-textarea>
          </ion-item>
        </div>

        <div class="input-actions">
          <ion-button class="audioButton" (click)="startRecord()"
            *ngIf="theMsgControl.value.length==0&&mediaSP.isNative">
            <img src="assets/imgs/microphone.svg" alt="SendAudio">
          </ion-button>
          <ion-button fill="clear" class="sendButton" *ngIf="theMsgControl.value.length>0||!mediaSP.isNative"
            (click)="send()">
            <img src="assets/imgs/awesome-location-arrow.svg" alt="Send message">
          </ion-button>
        </div>
      </form>
    </div>

    <!-- Audio Message-->
    <div class="recordingFooter" *ngIf="mediaSP.recording">
      <div class="recording-text" [class.has-content]="respondingMessage" [class.has-reply]="respondingMessage">
        <!-- Response to-->
          <div *ngIf="respondingMessage" class="replied-to-snippet {{respondedMessage.position}}">
            <div class="replied-to-header">
              <ng-container *ngIf="respondedMessage?.position == 'right'">
                {{ 'you' | translate }}
              </ng-container>
              <ng-container *ngIf="respondedMessage?.position == 'left'">
                {{ otherSoul?.firstName }} </ng-container>
            </div>

          <div *ngIf="respondedMessage?.filename" class="replied-to-content replied-to-content--audio">
            <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
            Audio {{ respondedMessage?.duration ? '(' + respondedMessage?.duration + 's)' : '' }}
          </div>
          <div *ngIf="!respondedMessage?.filename" class="replied-to-content replied-to-content--text">
            {{ respondedMessage?.message }}
          </div>
          <ion-icon name="close" (click)="dismissRespondMessage()" class="close-icon"></ion-icon>
        </div>


        <div class="recording-text-inner">
          <div class="cancelButton" shape="round" color="primary" (click)="cancelAudio()">
            <ion-icon src="assets/imgs/custom-svg/trash.svg"></ion-icon>
            <div class="cancelText">
              {{'cancel' | translate}}
            </div>
          </div>
          <div (swipe)="swipeEventAudio($event)" class="audio-time">
            <div class="time-elapsed">0:{{formattedelapsed}}</div>
            <div class="sendButtonStop">
              <ion-icon src="assets/imgs/custom-svg/custom_mic.svg" alt="red-microphone"></ion-icon>

            </div>
          </div>
        </div>
      </div>
      <ion-button fill="clear" class="sendButton" (click)="stopRecord()"
        *ngIf="mediaSP.recording || mediaSP.recording&&theMsgControl.value.length==0">
        <img src="assets/imgs/awesome-location-arrow.svg" alt="Stop-recording">
      </ion-button>
    </div>
  </div>
</ion-content>